import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'TekHub';
const SITE_URL = 'https://tekhubb.co';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

/**
 * Per-route SEO tags. Pass `title` and optionally `description` / `path`.
 * When `noindex` is true (default for auth-walled routes), search engines
 * are told to skip indexing — useful for /signin, /signup, /dashboard/*.
 */
export default function SEO({
  title,
  description = 'TekHub — one quiet workspace for small teams. People, projects, leave, and payroll in one place.',
  path = '/',
  image = DEFAULT_IMAGE,
  noindex = false,
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
